module.exports = __webpack_public_path__ + "static/img/7.3b2219b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/3/sp/7.png
// module id = JQEG
// module chunks = 0